/**
 * Navigation action for IA Corners.
 * Handles routing to the IA Corner page when a user selects an IA Corner item.
 */

import Pages from '@pages';
import { pushRoute } from '../../store/thunks/route.thunk';
import { store } from '../../store/store';

/**
 * Navigates to the IA Corner page with the specified ID.
 * Dispatches a route change to display the IA Corner content.
 *
 * @param {string} id - The unique identifier of the IA Corner to navigate to
 */
export default function goToIACorner(id: string) {
  if (id) {
    store.dispatch(
      pushRoute({
        route: { Page: Pages.IA_CORNER },
        params: { current: { id }, push: true },
      })
    );
  }
}
